export default __webpack_public_path__ + "images/e0d7d7254ac0545743fc7af09c1e977b.svg";